var Dlrt;
(function (Dlrt) {
    class DateRangePicker {
        constructor(options) {
            this.options = options;
            this.startDatePicker = this.options.startDatePickerInput.makeSingleDatePicker({
                dateInput: this.options.startDateInput,
                onApply: () => this.options.onApply(),
                onClear: () => this.options.onClear()
            });
            this.endDatePicker = this.options.endDatePickerInput.makeSingleDatePicker({
                dateInput: this.options.endDateInput,
                onApply: () => this.options.onApply(),
                onClear: () => this.options.onClear()
            });
        }
        getStartDate() {
            return this.startDatePicker.getDate();
        }
        getEndDate() {
            return this.endDatePicker.getDate();
        }
        hasValue() {
            return this.getStartDate() || this.getEndDate();
        }
        clear() {
            this.startDatePicker.clear();
            this.endDatePicker.clear();
        }
    }
    Dlrt.DateRangePicker = DateRangePicker;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=DateRangePicker.js.map
